import styled from "styled-components/macro";

const Residences = ({ children }) => {
  return <ResidencesPageWr>{children}</ResidencesPageWr>;
};

const ResidencesPageWr = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  /* background-color: var(--primary); */

  .residencesCategory {
    position: absolute;
    left: 5%;
    bottom: 0;
    margin: 4rem 2rem;
    display: flex;
    border: 0.5px solid var(--primary);

    .buttons {
      background-color: transparent;
      color: var(--primary);
      padding: 0.75rem 4rem;
      border: 0.5px solid var(--primary);
    }

    .active {
      background-color: var(--primary);
      color: white;
    }
  }

  .residences-table {
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    pointer-events: none;

    .table {
      pointer-events: all;
      padding: 2em 1em;
    }
  }

  .canvas_view {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: end;
    align-items: center;
  }

  .filters-container {
    width: 32%;
    height: 60%;
    margin-top: auto;
    margin-left: 2rem;

    .filters {
      border: 1px solid var(--accent);
      background-color: var(--primary);
      color: #fff;
    }
  }

  .residences-popup {
    z-index: 1;
    pointer-events: none;
    position: relative;
    width: 100%;
    height: 100%;

    > * {
      pointer-events: all;
    }

    .addToFavorites {
      position: absolute;
      bottom: 0;
      left: 0;
      margin: 2rem;
      padding: 0.25rem 3.25rem;
      border-radius: 5px;
      z-index: 100;
    }

    .backButton {
      top: 15%;
    }
  }

  .imageOverlayToggle {
    position: absolute;
    bottom: 0;
    left: 13%;
    margin: 2rem;
    background-color: var(--secondary);
    z-index: 5;
    border-radius: 5px;
  }
`;

export default Residences;
